import { render, staticRenderFns } from "./subjectResearch.vue?vue&type=template&id=3df2b31f&scoped=true&"
import script from "./subjectResearch.vue?vue&type=script&lang=js&"
export * from "./subjectResearch.vue?vue&type=script&lang=js&"
import style0 from "./subjectResearch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df2b31f",
  null
  
)

export default component.exports